import React from "react";
import PropTypes from "prop-types";

/**
 *  Options:
 *     wrapper enclcosing glossary glossary and trash buttons
 */

export function Options(props) {
  return <div className={props.className}>{props.children}</div>;
}

Options.propTypes = {
  /**
   * className
   */
  className: PropTypes.string,
  /**
   * child components
   */
  children: PropTypes.array,
};
